<template>
  <div class="neo-section">
    <div class="neo-container">
      <div data-aos="fade-up">
        <el-row type="flex" :gutter="80">
          <el-col :md="8">
            <div class="neo-form__title">
              <h2>Exclusive Access for When We Launch</h2>
            </div>
          </el-col>
          <el-col :md="16">
            <div class="neo-form__description">
              <p>
                Send money quickly to your family in Nigeria and pay back with
                no interest. With NEO, you can easily check your money anytime
                and make simple monthly repayments!
              </p>
              <neo-signup-form />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import NeoSignupForm from "@/components/Website/NeoSignupForm.vue";

export default {
  name: "NeoExclusiveAccess",
  components: { NeoSignupForm },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.el-select {
  width: 100%;
}
.neo-form__description {
  p {
    margin-bottom: 40px;
  }
}
</style>
